/* eslint-disable */
// /src/pages/NaverBlogPage.jsx
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Wrap = styled.div`
  min-height: 100vh;
  background: #eaf3ff;
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  min-height: 100dvh;
  background: #f7faff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
`;

const TopBar = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-bottom: 1px solid #dde7fb;

  button {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #111;
    font-weight: 700;
    padding: 6px 8px;
    border-radius: 10px;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const Body = styled.div`
  flex: 1;
  padding: 20px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.06);
  padding: 18px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
`;

const Desc = styled.p`
  margin: 0;
  font-size: 13px;
  color: #64748b;
  white-space: pre-line;
`;

const UrlBox = styled.div`
  margin-top: 6px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f1f5f9;
  font-size: 12px;
  color: #0f172a;
  word-break: break-all;
`;

const OpenBtn = styled.button`
  margin-top: 10px;
  align-self: flex-start;
  padding: 10px 16px;
  border-radius: 999px;
  border: 0;
  background: #16a34a;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:active {
    transform: translateY(1px);
  }
`;

const BLOG_URL = "https://blog.naver.com/heyway_officia/223906076498";

export default function NaverBlogPage() {
  const nav = useNavigate();

  const isApp =
    typeof window !== "undefined" && !!window.ReactNativeWebView;

  const goBack = () => nav(-1);

  const handleOpenExternal = () => {
    if (typeof window === "undefined") return;

    // 앱(WebView) 안이면 같은 창에서 전체 화면으로 블로그 열기
    if (window.ReactNativeWebView) {
      window.location.href = BLOG_URL;
      return;
    }

    // 일반 브라우저: 새 탭
    window.open(BLOG_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Wrap>
      <Sheet>
        <TopBar>
          <button onClick={goBack} aria-label="뒤로가기">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#111"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
            뒤로
          </button>
        </TopBar>

        <Body>
          <Card>
            <Title>DH모빌리티 네이버 공식 블로그</Title>
            <Desc>
              {"서비스 소식과 이벤트, 기사 보도 등을\n네이버 블로그에서 확인하실 수 있습니다."}
            </Desc>

            <UrlBox>{BLOG_URL}</UrlBox>

            <OpenBtn type="button" onClick={handleOpenExternal}>
              {isApp ? "네이버 블로그 바로 열기" : "새 창에서 열기"}
            </OpenBtn>
          </Card>
        </Body>
      </Sheet>
    </Wrap>
  );
}
